<template>
  <div id="expiracion">
    <!-- expiracion de pago -->

    <h4 class="bold mb-2">Actualizar expiración de pago</h4>

    <h4 class="bold my-4">REQUEST</h4>

    <!-- -------------HEADERS--------------- -->
    <h4 class="my-4">Headers</h4>
    <v-simple-table fixed-header height="150px">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              ATRIBUTO
            </th>
            <th class="text-left">
              TIPO
            </th>
            <th class="text-left">
              REQUERIDO
            </th>
            <th class="text-left">
              PATTERN
            </th>
            <th class="text-left">
              DESCRIPCIÓN
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in headersExpiracion" :key="item.name">
            <td>{{ item.atributo }}</td>
            <td>{{ item.tipo }}</td>
            <td>{{ item.requerido }}</td>
            <td>
              <code
                style="background-color: #f5f5f5; padding: 2px 4px; border-radius: 4px; color: #000"
                >{{ item.pattern }}
              </code>
            </td>
            <td>{{ item.descripcion }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- ----------PARAMS----------- -->
    <p class="my-4">Path parameters</p>
    <v-simple-table fixed-header height="150px">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              ATRIBUTO
            </th>
            <th class="text-left">
              TIPO
            </th>
            <th class="text-left">
              REQUERIDO
            </th>
            <th class="text-left">
              DESCRIPCIÓN
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paramsExpiracion" :key="item.name">
            <td>{{ item.atributo }}</td>
            <td>{{ item.tipo }}</td>
            <td>{{ item.requerido }}</td>
            <td>{{ item.descripcion }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- ----------RESPONSE----------- -->
    <h4 class="bold my-4">RESPONSE</h4>
    <p class="bold">Atributos del objeto de respuesta.</p>
    <v-simple-table fixed-header height="200px">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              ATRIBUTO
            </th>
            <th class="text-left">
              TIPO
            </th>
            <th class="text-left">
              DESCRIPCIÓN
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in responseExpiracion" :key="item.name">
            <td>{{ item.atributo }}</td>
            <td>{{ item.tipo }}</td>
            <td>{{ item.descripcion }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- patch Expirar Pago -->
    <v-divider class="mt-5 mb-4"></v-divider>
    <h4 class="bold mb-4" id="crear-solicitud-pago">
      <span class="metodo-put">PUT</span> Actualizar Expiración Pago
    </h4>
    <!--URL de la solicitud-->
    <div class="url-container">
      <p
        class="
      d-flex
        align-items-center
        justify-content-center
        mb-0
      "
      >
        https://sb-wee.ar/administracion/update-pago-expiration?uuid=93a03066-83f7-41a0-8b91-11062b813258&fecha_hora_expiracion=10-05-2025
        12:00:00
      </p>
    </div>
    <!-- Headers -->
    <h4 class="bold mt-4">HEADERS</h4>
    <v-divider></v-divider>
    <div>
      <v-row>
        <v-col cols="6">
          <p class="bold ml-4">Content-Type</p>
        </v-col>
        <v-col cols="6">
          <p>application/json</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <p class="bold ml-4">apiKey</p>
        </v-col>
        <v-col cols="6">
          <p>{<span>{ apiKey }</span>}</p>
        </v-col>
      </v-row>
    </div>
    <!-- --------------------BLOQUE CODIGO EJEMPLO: RESPONSE --------------------- -->
    <div>
      <h6 class="bold mt-4">Example Response</h6>
      <div class="mt-2 mb-4">
        <pre>
            <code class="language-json code-block">
        {
          "data": {
            "external_reference": "5976282",
            "fecha_hora_expiracion": "2025-04-30T13:38:00Z",
            "payer_email": "correo@gmail.com",
            "payer_name": "NOMBRE APELLIDO",
            "uuid": "3fe900c4-fc79-4c36-84da-0dfb3b181133"
        },
            "message": "La fecha de expiración del pago se actualizó correctamente",
            "status": true
        }
            </code>
        </pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActualizarExpiracionPago",
  data() {
    return {
      headersExpiracion: [
        {
          atributo: "Content-Type",
          tipo: "String",
          requerido: "SI",
          pattern: "application/json",
          descripcion:
            "El tipo MIME del contenido del cuerpo enviado. Por defecto JSON es Unicode UTF-8. No se debe configurar otro charset.",
        },

        {
          atributo: "apiKey",
          tipo: "String",
          requerido: "SI",
          pattern: "API Key",
          descripcion: "ApiKey de la cuenta a la que pertenece el pago.",
        },
      ],
      paramsExpiracion: [
        {
          atributo: "uuid",
          tipo: "String",
          requerido: "SI",
          descripcion: "UUID del pago.",
        },
        {
          atributo: "fecha_hora_expiracion",
          tipo: "String",
          requerido: "SI",
          descripcion:
            "Fecha y hora de expiración. Formato DD-MM-YYYY HH:mm:ss ",
        },
      ],
      responseExpiracion: [
        {
          atributo: "data",
          tipo: "Object",
          descripcion: "Datos de respuesta.",
        },
        {
          atributo: "message",
          tipo: "String",
          descripcion: "Mensaje de la respuesta.",
        },
        {
          atributo: "status",
          tipo: "Boolean",
          descripcion: "Estado de la respuesta.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
.italic {
  font-style: italic;
}
.metodo-put {
  color: rgb(173, 122, 3);
  font-size: 20px;
  margin-right: 10px;
}
.url-container {
  background-color: #fff;
  border-radius: 4px;
  color: #000;
  height: 40px;
  display: flex;
  padding-left: 10px;
}
.code-block {
  font-size: 14px;
}
</style>
